import React from 'react';
import { Tag } from '../../../ui/Tag/Tag';
import { toDisplay } from '../../../features/relance/customEmailTemplate/customTemplateMarkers';
import { contentFor, definedLanguages } from '../../../types/customEmailTemplate';
import type { CustomEmailTemplateSetting } from '../../../types/customEmailTemplate';

interface CustomEmailTemplatePreviewProps {
    template: CustomEmailTemplateSetting | null;
}

export const CustomEmailTemplatePreview: React.FC<CustomEmailTemplatePreviewProps> = ({ template }) => (
    <div className="flex flex-col gap-s">
        {definedLanguages(template).map(language => {
            const content = contentFor(template, language);
            if (!content) return null;
            return (
                <div key={language} data-testid={`settings-custom-email-template-preview-${language}`}
                    className="rounded-md border border-line-subtle bg-surface-secondary px-m py-s flex flex-col gap-xs">
                    <div className="flex items-center gap-s min-w-0">
                        <Tag tone="neutral">{language}</Tag>
                        <span className="text-body-emphasized text-content truncate">{toDisplay(content.subject, language)}</span>
                    </div>
                    <p className="text-s text-content-secondary whitespace-pre-line line-clamp-3">{toDisplay(content.body, language)}</p>
                </div>
            );
        })}
    </div>
);
